import React from 'react';
import { 
    Code,
    Heading, 
    Stack,
    useToast,
    VStack,
} from '@chakra-ui/react';

import { TextoInicioMapa } from '../components/mapa/TextoInicioMapa';
import { Mapa } from '../components/mapa/Mapa'


export function Mapas() {

    const toast = useToast()
    const id = 'mapas-toast'

    if (!toast.isActive(id)) {
        toast({ 
        id,
        description: "Estoy actualizando esta sección para tener controlados los lugares que he visitado.",
        duration: 10000,
        isClosable: true,
        position: 'down',
        title: 'Sección Mapas en construcción',
        status: 'info',
        variant: 'solid'
        })
    }

    return(
        <>
            <VStack 
                // backgroundColor={'gray.700'} 
                mt={10} 
                rounded={'2xl'}
                width='80%' // Fija el ancho a 600px
                maxW='80%' // Asegura que no se expanda más allá de 600px
                minW='80%' // Asegura que no se contraiga menos de 600px
                >
                <Heading>Mapas</Heading>

                <Stack direction='row'>
                    <Code 
                        mb={'20px'}
                        colorScheme='cyan' 
                        children='Hace años dejé de viajar, está todo infectado de gente. ¡Qué pereza!' />
                </Stack>
                
                <TextoInicioMapa />
                <Mapa />

            </VStack>
            
        </>
    )
}
